var App = App || {};

App.Masthead = (function ($) {
    "use strict";

    function init() {
        var $mastheads = $(".widget-masthead");
        $mastheads.each(function() {
            var $masthead = $(this);
            var $videoContainer = $masthead.find(".video-container");
            var $play = $masthead.find(".play-button");
            var $pause = $masthead.find(".pause-button");

            if (!$videoContainer.length) {
                return;
            }

            calculateDynamicHeights();

            var resizeTimer;
            $(window).on("resize", function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(calculateDynamicHeights, 100);
            });

            if (window.matchMedia) {
                var mql = window.matchMedia("(orientation: portrait)");
                mql.addEventListener("change", function() {
                    setTimeout(calculateDynamicHeights, 200);
                });
            }

            $(window).on("orientationchange", function() {
                setTimeout(calculateDynamicHeights, 200);
            });

            $masthead.find(".view-more-link > a").on("click", function(e) {
                e.preventDefault();
                scrollToNextWidget($masthead);
            });

            watchForSmartBanner();

            if ($videoContainer.length) {
                var $videoInset = $masthead.find(".video-inset");
                var iframe = $videoInset.find("iframe")[0];

                if (!iframe) {
                    return;
                }

                iframe.onerror = function () {
                    showVideoFallback($masthead);
                };

                if ($videoContainer.hasClass("is-youtube")) {
                    initializeYouTubeVideo($masthead, $videoContainer, iframe, $play, $pause);
                }

                if ($videoContainer.hasClass("is-vimeo")) {
                    initializeVimeoVideo($masthead, $videoContainer, iframe, $play, $pause);
                }
            }
        });
    }

    function initializeYouTubeVideo($masthead, $videoContainer, iframe, $play, $pause) {
        if (iframe.dataset.src && !iframe.src) {
            iframe.src = iframe.dataset.src;
        }

        loadPlayerAPIDeferred(function() {
            if (typeof YT === "undefined" || !YT.Player) {
                showVideoFallback($masthead);
                return;
            }

            try {
                var player = new YT.Player(iframe.id, {
                    events: {
                        "onReady": function(event) {
                            onYouTubePlayerReady(event, $masthead, $play, $pause);
                        },
                        "onStateChange": function(event) {
                            onYouTubePlayerStateChange(event, $play, $pause, $masthead);
                        },
                        "onError": function (errorCode) {
                            showVideoFallback($masthead);
                        }
                    }
                });
            } catch (e) {
                showVideoFallback($masthead);
            }
        }, "https://www.youtube.com/player_api");
    }

    function initializeVimeoVideo($masthead, $videoContainer, iframe, $play, $pause) {
        loadVimeoAPIDeferred(function() {
            if (typeof Vimeo === "undefined" || !Vimeo.Player) {
                showVideoFallback($masthead);
                return;
            }

            try {
                var player = new Vimeo.Player(iframe);

                var vimeoLoadTimeout = setTimeout(function () {
                    showVideoFallback($masthead);
                }, 5000);

                player.on("loaded", function () {
                    clearTimeout(vimeoLoadTimeout);

                    player.getError().then(function(error) {
                        if (!error) {
                            onVimeoPlayerAPIReady(player, $masthead, $play, $pause);
                        } else {
                            showVideoFallback($masthead);
                        }
                    });
                });

                player.on("error", function () {
                    clearTimeout(vimeoLoadTimeout);
                    showVideoFallback($masthead);
                });
            } catch (e) {
                showVideoFallback($masthead);
            }
        });
    }

    function loadPlayerAPIDeferred(callback, apiUrl) {
        if (loadPlayerAPIDeferred._scheduled) {
            return;
        }

        loadPlayerAPIDeferred._scheduled = true;

        if (document.readyState === "loading") {
            $(window).on("load", function() {
                scheduleIdleCallback(callback, apiUrl);
            });
        } else {
            scheduleIdleCallback(callback, apiUrl);
        }
    }

    function scheduleIdleCallback(callback, apiUrl) {
        if ("requestIdleCallback" in window) {
            requestIdleCallback(function() {
                loadExternalAPI(apiUrl, callback);
            }, { timeout: 2000 });
        } else {
            setTimeout(function() {
                loadExternalAPI(apiUrl, callback);
            }, 100);
        }
    }

    function loadExternalAPI(apiUrl, callback) {
        if (!window.App._youTubeCallbacks) {
            window.App._youTubeCallbacks = [];
            window.onYouTubeIframeAPIReady = function() {
                while (window.App._youTubeCallbacks.length > 0) {
                    var cb = window.App._youTubeCallbacks.shift();
                    cb();
                }
            };
        }
        window.App._youTubeCallbacks.push(callback);
        if (typeof YT !== "undefined" && YT.Player) {
            callback();
            return;
        }
        if (!window.App._youTubeScriptLoading) {
            window.App._youTubeScriptLoading = true;
            var script = document.createElement("script");
            script.src = apiUrl;

            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
        }
    }

    function loadVimeoAPIDeferred(callback) {
        if (document.readyState === "loading") {
            $(window).on("load", function() {
                scheduleIdleCallbackWithVimeoAPI(callback);
            });
        } else {
            scheduleIdleCallbackWithVimeoAPI(callback);
        }
    }

    function scheduleIdleCallbackWithVimeoAPI(callback) {
        if ("requestIdleCallback" in window) {
            requestIdleCallback(function() {
                loadVimeoAPI(callback);
            }, { timeout: 2000 });
        } else {
            setTimeout(function() {
                loadVimeoAPI(callback);
            }, 100);
        }
    }

    function loadVimeoAPI(callback) {
        var iframes = document.querySelectorAll(".video-inset iframe[data-src]");
        iframes.forEach(function(iframe) {
            if (!iframe.src) {
                iframe.src = iframe.dataset.src;
            }
        });
        if (typeof Vimeo === "undefined") {
            var script = document.createElement("script");
            script.src = "//player.vimeo.com/api/player.js";
            script.onload = function() {
                callback();
            };

            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
        } else {
            callback();
        }
    }

    function scrollToNextWidget($currentWidget) {
        var scrollDestination = $currentWidget.data("scroll-destination");
        var $targetWidget;
        
        if (scrollDestination) {
            $targetWidget = $(scrollDestination);
        } else {
            $targetWidget = $currentWidget.nextAll(".widget").first();
        }
        
        if ($targetWidget.length) {
            var widgetElement = $targetWidget[0];
            
            if (widgetElement) {
                widgetElement.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }

    function calculateDynamicHeights() {
        var $header = $("header");
        var $alerts = $("#Alerts");
        var $smartBanner = $(".smartbanner");

        if ($header.length) {
            var headerHeight = $header.outerHeight();

            document.documentElement.style.setProperty("--header-height", headerHeight + "px");
        }

        if ($alerts.length) {
            var alertsHeight = $alerts.outerHeight();

            document.documentElement.style.setProperty("--alerts-height", alertsHeight + "px");
        } else {
            document.documentElement.style.setProperty("--alerts-height", "0px");
        }

        if ($smartBanner.length && $("html").hasClass("smartbanner-show")) {
            var smartBannerHeight = $smartBanner.outerHeight();

            document.documentElement.style.setProperty("--smart-banner-height", smartBannerHeight + "px");
        } else {
            document.documentElement.style.setProperty("--smart-banner-height", "0px");
        }
    }

    function watchForSmartBanner() {
        if (window.MutationObserver) {
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === "attributes" && mutation.attributeName === "class") {
                        calculateDynamicHeights();
                    }
                });
            });

            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["class"]
            });
        }
    }

    return {
        init: init,
        updateHeights: calculateDynamicHeights
    };
})(jQuery);



$(function () {
    App.Masthead.init();
});

function showVideoFallback($widget) {
    if (!$widget || !$widget.length) {
        return;
    }

    var fallbackDesktop = $widget.data("fallback-desktop");

    if (!fallbackDesktop) {
        return;
    }

    var $videoContainer = $widget.find(".video-container");
    var $videoInset = $widget.find(".video-inset");

    $videoContainer.css("background-image", "url('" + fallbackDesktop + "')");
    $videoInset.hide();
}

function togglePlayPauseButtons($play, $pause, isPlaying) {
    $play.toggleClass("d-none", isPlaying);
    $pause.toggleClass("d-none", !isPlaying);
}

function onYouTubePlayerReady(event, $widget, $play, $pause) {
    var player = event.target;
    var $videoInset = $widget.find(".video-inset");
    $videoInset.addClass("is-ready");
    player.mute();
    player.playVideo();
    togglePlayPauseButtons($play, $pause, true);
    $play.off("click").on("click", function () {
        player.playVideo();
        togglePlayPauseButtons($play, $pause, true);
        $pause.focus();
    });
    $pause.off("click").on("click", function () {
        player.pauseVideo();
        togglePlayPauseButtons($play, $pause, false);
        $play.focus();
    });
}

function onYouTubePlayerStateChange(event, $play, $pause, $widget) {
    if (event.data >= 0) {
        var $masthead = $widget;
        var $videoInset = $masthead.find(".video-inset");
        if (!$videoInset.hasClass("is-ready")) {
            $videoInset.addClass("is-ready");
        }
    }
    togglePlayPauseButtons($play, $pause, event.data == "1");
}

function onVimeoPlayerAPIReady(player, $widget, $play, $pause) {
    var $videoInset = $widget.find(".video-inset");
    $videoInset.addClass("is-ready");
    player.getError().then(function(error) {
        if (error) {
            showVideoFallback($widget);
            return;
        }
        player.play().then(function () {
            togglePlayPauseButtons($play, $pause, true);
        }).catch(function () {
            showVideoFallback($widget);
        });
        onVimeoPlayerStateChange(player, $play, $pause);
    });
    $play.off("click").on("click", function () {
        player.play().then(function () {
            togglePlayPauseButtons($play, $pause, true);
            $pause.focus();
        });
    });
    $pause.off("click").on("click", function () {
        player.pause().then(function () {
            togglePlayPauseButtons($play, $pause, false);
            $play.focus();
        });
    });
}

function onVimeoPlayerStateChange(player, $play, $pause) {
    player.on("play", function () {
        togglePlayPauseButtons($play, $pause, true);
    });

    player.on("pause", function () {
        togglePlayPauseButtons($play, $pause, false);
    });
}